'use client'

import { observer } from 'mobx-react-lite'
import { useRouter } from 'next/router'
import { Fragment, useEffect, useState } from 'react'
import BlockPanel from '@/components/v1/ui/block'
import StepBullet from '@/components/v1/ui/step'
import { RMW_LOGO_URL } from '@/constants'
import { ApplyContent, ApplyPanel, ApplyWrapper } from './apply.style'
import ApplyStepOne from './applyStepOne'
import Head from 'next/head'
import { useUser } from '@/hooks/use-user'
import { api } from '@/api'
import { Image } from '@/components/v2/atoms/image/image'
import { sortBusinessCategoriesByName } from '@/utils/sort-bc-by-name'

export const getServerSideProps = async () => {
  const [err, businessCategoryList] = await api.be.businessCategories.getMany()
  if (err) throw err

  return {
    props: {
      businessCategoryList: sortBusinessCategoriesByName(businessCategoryList),
    },
  }
}

type AllowedSteps = 'form' | 'pricing'

function isAllowedStep(view: string): view is AllowedSteps {
  return view === 'form' || view === 'pricing'
}

const OnBoadingPage = observer(({ businessCategoryList }: any) => {
  const defaultStep = 'form'
  const route = useRouter()
  const [step, setStep] = useState<AllowedSteps>(defaultStep)
  const { query } = route
  const { view }: any = query
  const { isSupplier } = useUser()

  const stepViews: { [key: string]: number } = {
    form: 1,
  }

  const stepUI: any = {
    form: () => <ApplyStepOne businessCategoryList={businessCategoryList} />,
  }

  useEffect(() => {
    if (!view || !isAllowedStep(view)) {
      setStep(defaultStep)
    } else {
      setStep(view)
    }
  }, [view])

  return (
    <>
      <Head>
        <title>Become a Recommended Supplier | Rock My Wedding</title>
        <meta
          name="description"
          content="We want you! Apply now to become one of Rock My Wedding's Recommended Suppliers. Gain access to your own supplier dashboard and profile on our site!"
        />
      </Head>
      <ApplyWrapper>
        <ApplyPanel>
          <BlockPanel uuid="1234" store={{}} edit={false}>
            <ApplyContent>
              {!isSupplier && (
                <Fragment>
                  <Image
                    src={RMW_LOGO_URL}
                    alt="Rock My Wedding"
                    width={175}
                    height={150}
                    fit
                  />
                  <StepBullet
                    steps={2}
                    set={stepViews[step] - 1}
                    colorType="black"
                  />
                </Fragment>
              )}
              {stepUI[step]()}
            </ApplyContent>
          </BlockPanel>
        </ApplyPanel>
      </ApplyWrapper>
    </>
  )
})

export default OnBoadingPage
